export const BA_STEPS = {
  COMPANY: 1,
  INTEGRATION: 2,
  ENROLLMENT: 3,
  ALERTS: 4,
  CARD: 5,
  TOP_UP: 6
}

export const businessSteps = [
  {
    id: 2,
    step: BA_STEPS.COMPANY,
    title: "Company profile",
    description: "Enter your business name and website URL",
    continue: "/create-account/business-info",
    isDivider: true
  },
  {
    id: 3,
    step: BA_STEPS.INTEGRATION,
    title: "Connect integration",
    description: "Connect Stripe, Shopify, or other processors",
    isDivider: true
  },
  {
    id: 4,
    step: BA_STEPS.ENROLLMENT,
    title: "Choose enrollment",
    description: "Turn on Ethoca, RDR, or CDRN coverage",
    isDivider: true
  },
  {
    id: 5,
    step: BA_STEPS.ALERTS,
    title: "Activate alerts",
    description: "Provide your billing descriptors and ARN codes (or BIN & CAID)",
    isDivider: true
  },
  {
    id: 6,
    step: BA_STEPS.CARD,
    title: "Link a card",
    description: "Enter your card details.",
    isDivider: true
  },
  {
    id: 7,
    step: BA_STEPS.TOP_UP,
    title: "Top up your balance",
    description: "Add funds to activate your chargeback protection."
  }
]
